export default __webpack_public_path__ + "static/media/BASE_TECNOLOGIA_RR_310_TABLERO_RACING_01.091b16e4.jpg";